export const tableStruct = {
    table: {
        bordered: true,
        pagination: true,
        scroll: {
          x: 500,
        },
      },
}